import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VcsService } from '../../../services/vcs.service';
import { BaseComponent } from '../../../../components/base/base.component';
import { WmsDialogComponent } from '../../../../components/wms-dialog/wms-dialog.component';
import { WmsDialogHeaderComponent } from '../../../../components/wms-dialog-header/wms-dialog-header.component';
import { WmsDialogBodyComponent } from '../../../../components/wms-dialog-body/wms-dialog-body.component';
import { WmsDialogFooterComponent } from '../../../../components/wms-dialog-footer/wms-dialog-footer.component';
import { DialogService } from "@wms/services";
import { TooltipModule } from "ngx-bootstrap/tooltip";

@Component({
  selector: 'wms-vcs-create-mr-dialog',
  templateUrl: './wms-vcs-create-mr-dialog.component.html',
  styleUrls: ['./wms-vcs-create-mr-dialog.component.less'],
  standalone: true,
  imports: [
    CommonModule,
    WmsDialogComponent,
    WmsDialogHeaderComponent,
    WmsDialogBodyComponent,
    WmsDialogFooterComponent,
    TooltipModule,
  ],
})
export class WmsVcsCreateMrDialogComponent extends BaseComponent {
  dialogService = inject(DialogService);
  vcsService = inject(VcsService);

  copyToClipboard(branch: string) {
    var temp = $("<textarea>");
    $("body").append(temp);
    temp.val(branch);
    temp.select();
    document.execCommand('copy');
    temp.remove();
  }
}
